 
import { IServerSideGetRowsParams } from 'ag-grid-community'
import { useAppDispatch, useAppSelector } from 'appState/store'
import { ObGrid } from '@outbound-ai/ursa'
import {
  CLAIMS_FILE_COLUMN,
  ROW_MODEL_TYPE,
} from 'features/claims/components/ClaimsTable/Internal/ClaimsTableConstants'
import { useEffect, useMemo, useState } from 'react'
import { FaTimes } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { notificator } from 'utils/notificator/notificator'
import { archiveClaims } from '../autoCheckApi'
import { updateCurrentBatch } from '../autoCheckSlice'
import { BatchTabType } from '../types'
import { NoContent } from '../utils'
import { createBatchServerSideDataSource } from '../utils/grid'
import { BatchGridArchivedConfig } from './AutoCheckGrid/gridConfig'

export const BatchArchived = () => {
  const dispatch = useAppDispatch()
  const { root, refresh } = useAppSelector((state) => state.batch)
  const [gridApi, setGridApi] = useState<any>(null)
  const [isselectedRows, setSelectedRows] = useState<any>([])

  const onGridReady = async (params: IServerSideGetRowsParams) => {
    setGridApi(params)
    params.api.sizeColumnsToFit()
    dispatch(updateCurrentBatch({ root: BatchTabType.Archived }))
    const dataSource = createBatchServerSideDataSource(BatchTabType.Archived)
    params.api.setGridOption('serverSideDatasource', dataSource)
  }

  const getRowId = useMemo(() => {
    return (params: any) => {
      const data = params.data
      return data.batchCode + data.batchId
    }
  }, [])

  const onSelectionChanged = (api: any) => {
    const selectedRows = api.getSelectedRows()
    setSelectedRows(selectedRows)
  }

  const deselectClaims = () => {
    gridApi.api.deselectAll()
    setSelectedRows([])
    const x = document.querySelector('#selectGridHeader') as HTMLInputElement
    x.checked = false
  }

  const onArchive = () => {
    const batchArchive = {
      batches: isselectedRows.map((item: any) => {
        return {
          batchId: item.batchId,
          archived: false,
        }
      }),
    }
    archiveClaims(batchArchive)
      .then((res) => {
        if (res) {
          dispatch(updateCurrentBatch({ root: BatchTabType.Archived, refresh: true }))
          setSelectedRows([])
          deselectClaims()
          notificator.notify({
            type: 'success',
            heading: 'Batch unarchived successfully',
          })
        }
      })
      .catch((err) => {
        notificator.notify({
          type: 'error',
          heading: err.response?.data?.detail || err.message,
        })
      })
  }

  useEffect(() => {
    if (refresh && gridApi) {
      gridApi.api.sizeColumnsToFit()
      const dataSource = createBatchServerSideDataSource(root)
      gridApi.api.setGridOption('serverSideDatasource', dataSource)
      dispatch(updateCurrentBatch({ root: BatchTabType.Archived, refresh: false }))
    }
  }, [refresh, root])

  return (
    <Div>
      {isselectedRows.length > 0 && (
        <div className="action-holder">
          <div className="actions">
            <span>{isselectedRows.length} batch selected </span>{' '}
            <Button variant="primary-outline" radius="rounded" size="small" onClick={onArchive}>
              UnArchive
            </Button>
          </div>
          <div>
            <Button variant="tertiary" onClick={deselectClaims}>
              <FaTimes /> Deselect & Cancel
            </Button>
          </div>
        </div>
      )}
      <div className="grid">
        <ObGrid
          reactiveCustomComponents={true}
          columnDefs={BatchGridArchivedConfig as any}
          rowModelType={ROW_MODEL_TYPE}
          onGridReady={onGridReady as any}
          defaultColDef={CLAIMS_FILE_COLUMN as any}
          rowSelection="multiple"
          paginationPageSize={20}
          cacheBlockSize={20}
          getRowId={getRowId}
          suppressRowClickSelection={true}
          onSelectionChanged={() => {
            onSelectionChanged(gridApi.api)
          }}
          onPaginationChanged={() => {
            if (isselectedRows.length > 0) {
              gridApi.api.deselectAll()
            }
          }}
          onFilterChanged={() => {
            if (isselectedRows.length > 0) {
              gridApi.api.deselectAll()
            }
          }}
          onSortChanged={() => {
            if (isselectedRows.length > 0) {
              gridApi.api.deselectAll()
            }
          }}
          rowHeight={50}
          noRowsOverlayComponent={NoContent}
        ></ObGrid>
      </div>
    </Div>
  )
}

const Div = styled.div`
  padding: 1.5rem 1rem 0rem 0rem;
  overflow: hidden;
  .grid {
    height: 570px;
  }
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    ${({ theme }) => theme.typography.h5.bold};
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .action-holder {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    .actions {
      display: flex;
      gap: 1rem;
      align-items: center;

      span {
        ${({ theme }) => theme.typography.m.medium};
        color: ${({ theme }) => theme.colors.neutral.neutral};
      }
    }
    width: 81%;
    position: absolute;
    z-index: 101;
    top: 87px;
    padding: ${({ theme }) => theme.spacing.xs};
    border-radius: 8px;
    box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.06);
    border: solid 1px ${({ theme }) => theme.colors.grey.lightest};
    background-color: ${({ theme }) => theme.colors.neutral.lightest};
  }
`
